import { render, staticRenderFns } from "./AddDiskOffering.vue?vue&type=template&id=350e739c&scoped=true&"
import script from "./AddDiskOffering.vue?vue&type=script&lang=js&"
export * from "./AddDiskOffering.vue?vue&type=script&lang=js&"
import style0 from "./AddDiskOffering.vue?vue&type=style&index=0&id=350e739c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350e739c",
  null
  
)

export default component.exports